import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  CustomInput,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import "./Properties.scss";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Select from "react-select";
import Dropzone from "react-dropzone";
import { useHistory } from "react-router";
import { imageUpload } from "../../services/BannersServices";
import { Constants } from "../../Constants";
import { fetchPropertyLabels } from "../../services/PropertyLabelsServices";
import {
  deleteData,
  deleteTag,
  getData,
  getTags,
  postData,
  postTag,
} from "../../services/SharedServices";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import { getCities, getStates } from "../../services/LocationsServices";
import { EditorState } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import {
  addProperty,
  editProperty,
  getProperty,
} from "../../services/PropertiesServices";
import { stateFromHTML } from "draft-js-import-html";
import ViewInWeb from "../../components/Common/ViewInWeb";
import Creatable from "react-select/creatable";
import { Category, getCategory } from "../../services/MercadoLibreService";
import { INFO_CASAS_CITIES } from "../../utils/CitiesInfoCasas";

const categories = [
  { value: "1", label: "Apartamentos" },
  { value: "2", label: "Campos" },
  { value: "3", label: "Casas" },
  { value: "8", label: "Chacras" },
  { value: "9", label: "Galpónes" },
  { value: "6", label: "Locales Comerciales" },
  { value: "7", label: "Oficinas" },
  { value: "5", label: "Otros" },
  { value: "4", label: "Terrenos" },
  { value: "10", label: "Logísticos" },
  { value: "11", label: "Hotel" },
  { value: "12", label: "Posada" },
];

const INFO_CASAS_CATEGORIES = [
  { value: 1, label: "Casa" },
  { value: 2, label: "Apartamento" },
  { value: 3, label: "Terreno" },
  { value: 4, label: "Local comercial" },
  { value: 5, label: "Oficina" },
  { value: 6, label: "Chacra / campo" },
  { value: 8, label: "Garaje / cochera" },
  { value: 9, label: "Negocio especial" },
  { value: 10, label: "Edificio" },
  { value: 11, label: "Hotel" },
  { value: 12, label: "Local industrial / galpón" },
];

function Properties(props: any) {
  const [selectedFiles, setselectedFiles] = useState<any[]>([]);
  const { id } = props.match.params;
  const [imageNewData, setImageNewData] = useState("");
  const [nameNewData, setNameNewData] = useState("");
  const [symbolNewData, setSymbolNewData] = useState("");
  const [loading, setLoading] = useState(false);
  const [datas, setDatas] = useState<any[]>([]);
  const [tags, setTags] = useState<any[]>([]);
  const [nameNewTag, setNameNewTag] = useState("");
  const [states, setStates] = useState<any>([]);
  const [cities, setCities] = useState([]);
  const [sold, setSold] = useState(false);
  const [rented, setRented] = useState(false);
  const [reserved, setReserved] = useState(false);
  const [label, setLabel] = useState({
    value: null,
    label: "Seleccionar etiqueta",
  });
  const [labelsOptions, setLabelsOptions] = useState<any[]>([]);
  const [state, setState] = useState<any>({});
  const [city, setCity] = useState<any>({});
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState<any>(null);
  const [address, setAddress] = useState("");
  const [money, setMoney] = useState({ value: "uyu", label: "UYU" });
  const [price, setPrice] = useState("");
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [typeOperation, setTypeOperation] = useState({
    value: "venta",
    label: "Venta",
  });
  const [isDevelopment, setIsDevelopment] = useState({
    value: "no",
    label: "No",
  });
  const [isHighList, setIsHighList] = useState({ value: "no", label: "No" });
  const [youtube, setYoutube] = useState("");
  const [description, setDescription] = useState(EditorState.createEmpty());
  const token = localStorage.getItem("authToken");
  const history = useHistory();
  const [isPropertyLoad, setIsPropertyLoad] = useState(false);
  const [featuresOptions, setFeaturesOptions] = useState([
    { label: "Características", value: "Características" },
    { label: "Amenities", value: "Amenities" },
  ]);
  const [featuresOptionsSelect, setFeaturesOptionsSelect] = useState(
    featuresOptions[0]
  );
  const [newUrlProperty, setNewUrlProperty] = useState("");
  const [urlsProperties, setUrlsProperties] = useState<any>([]);
  const [categoryMeli, setCategoryMeli] = useState<any>([]);
  const [categoryMeliSelect, setCategoryMeliSelect] = useState({
    value: null,
    label: "Seleccionar categoría",
  });
  const [categoryWithOperationMeli, setCategoryWithOperationMeli] =
    useState(null);
  const [meliHighlight, setMeliHighlight] = useState({
    value: 0,
    label: "No",
  });
  const [meliId, setMeliId] = useState(null);
  const [meliShared, setMeliShared] = useState({
    value: 0,
    label: "No",
  });
  const [meliUrl, setMeliUrl] = useState(null);
  const [infoCasasShared, setInfoCasasShared] = useState({
    value: 0,
    label: "No",
  });
  const [infoCasasCategory, setInfoCasasCategory] = useState<any>({
    value: null,
    label: "Seleccionar categoría",
  });
  const [infoCasasCity, setInfoCasasCity] = useState<any>({
    value: null,
    label: "Seleccionar ciudad",
  });
  const [banner, setBanner] = useState("");
  const [imageTmp, setImageTmp] = useState("");
  const [reference, setReference] = useState("");

  const LAND_ACCESS = [
    { value: "Tierra", label: "Tierra" },
    { value: "Arena", label: "Arena" },
    { value: "Asfalto", label: "Asfalto" },
    { value: "Otro", label: "Otro" },
    { value: "Ripio", label: "Ripio" },
  ];

  useEffect(() => {
    async function init() {
      await fetchLabels();
      await fetchCategoryMeli();
      await fetchData();
      await fetchTags();
      await fetchStates();
    }
    init();
  }, []);

  useEffect(() => {
    if (datas.length && tags.length && states.length) {
      if (Number(id) !== 0 && !isPropertyLoad) {
        fetchProperty();
        setIsPropertyLoad(true);
      }
    }
  }, [datas, tags, states]);

  const fetchCategoryMeli = async () => {
    setLoading(true);
    const data = await getCategory("MLU1459", token);
    setCategoryMeli(data);
    setLoading(false);
  };

  const fetchProperty = async () => {
    try {
      setLoading(true);
      let response = await getProperty({
        token,
        id: Number(id),
      });
      const {
        address,
        category_id,
        city,
        data,
        tags: tagsPr,
        description,
        highlight,
        is_growth,
        location_lat,
        location_lon,
        medias,
        money,
        operation_type,
        price,
        state,
        title,
        youtube,
        featureOption,
        properties,
        sold,
        rented,
        reserved,
        label,
        meli_category,
        meli_highlight,
        meli_id,
        meli_shared,
        meli_url,
        info_casas_shared,
        info_casas_category,
        info_casas_city,
        reference,
      } = response.data.data;

      setMeliUrl(meli_url);
      setMeliId(meli_id);
      setMeliShared({
        value: meli_shared ? 1 : 0,
        label: meli_shared ? "Si" : "No",
      });
      setInfoCasasShared({
        value: info_casas_shared ? 1 : 0,
        label: info_casas_shared ? "Si" : "No",
      });
      if (info_casas_category) {
        const infoCasasCategory = INFO_CASAS_CATEGORIES.find(
          (cat) => cat.value === info_casas_category
        );
        if (infoCasasCategory) {
          setInfoCasasCategory({
            value: infoCasasCategory?.value,
            label: infoCasasCategory?.label,
          });
        }
      }
      if (info_casas_city) {
        let infoCasasCity;
        for (const value of Object.values(INFO_CASAS_CITIES)) {
          infoCasasCity = value.find((city) => city.value === info_casas_city);
          if (infoCasasCity) {
            break;
          }
        }
        if (infoCasasCity) {
          setInfoCasasCity({
            value: infoCasasCity?.value,
            label: infoCasasCity?.label,
          });
        }
      }
      setMeliHighlight({
        value: meli_highlight ? 1 : 0,
        label: meli_highlight ? "Si" : "No",
      });
      setCategoryWithOperationMeli(meli_category);
      if (meli_category && categoryMeli && categoryMeli.children_categories) {
        const categoryMeliTmp = (await getCategory(
          meli_category,
          token
        )) as any;
        const categoryMeliTmpSelect = categoryMeli.children_categories.find(
          (c: any) => c.id === categoryMeliTmp.path_from_root[1].id
        );
        setCategoryMeliSelect({
          value: categoryMeliTmpSelect.id,
          label: categoryMeliTmpSelect.name,
        });
      }

      setTitle(title);
      setLat(location_lat);
      setLng(location_lon);
      setIsHighList({
        value: highlight ? "si" : "no",
        label: highlight ? "Si" : "No",
      });
      setIsDevelopment({
        value: is_growth ? "si" : "no",
        label: is_growth ? "Si" : "No",
      });
      setDescription(EditorState.createWithContent(stateFromHTML(description)));
      setAddress(address);
      setPrice(price);
      setState({ value: state.id, label: state.name });
      await fetchCities(state.id);
      setCity({ value: city.id, label: city.name });
      setUrlsProperties(properties ? JSON.parse(properties) : []);
      let categoriesIds = category_id.toString().split(",");
      let arrayToPush = category ?? [];
      categories.map((item: any) => {
        if (categoriesIds.includes(item.value)) {
          arrayToPush = [
            ...arrayToPush,
            { value: item.value, label: item.label },
          ];
        }
      });
      setCategory(arrayToPush);
      setYoutube(youtube);
      setTypeOperation({
        value: operation_type === 1 ? "venta" : "alquiler",
        label: operation_type === 1 ? "Venta" : "Alquiler",
      });
      setMoney({ value: money, label: money.toUpperCase() });
      if (!featuresOptions.find((fo) => fo.value === featureOption)) {
        setFeaturesOptions([
          ...featuresOptions,
          {
            value: featureOption,
            label: featureOption,
          },
        ]);
      }
      setFeaturesOptionsSelect({
        value: featureOption,
        label: featureOption,
      });
      setSold(sold);
      setRented(rented);
      setReserved(reserved);
      setReference(reference);
      const labelOption = labelsOptions.find(
        (item) => Number(item.value) === Number(label)
      );
      setLabel({
        value: labelOption ? label : null,
        label: labelOption ? labelOption.label : "Seleccionar etiqueta",
      });

      // DATAS
      const datasTmp = [...datas];
      data.map((item: any) => {
        datasTmp.map((dt) => {
          if (item.data_id === dt.id) {
            dt.value = item.realValue;
            dt.checked = item.checked;
          }
        });
      });
      setDatas(datasTmp);

      // TAGS
      const tagsTmp = [...tags];
      tagsPr.map((item: any) => {
        tagsTmp.map((tg) => {
          if (item.tag_id === tg.id) {
            tg.checked = true;
          }
        });
      });
      setTags(tagsTmp);

      // MEDIAS
      setselectedFiles(medias);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const fetchStates = async () => {
    try {
      const response = await getStates({
        token: token,
      });
      setStates(response.data.data);
    } catch (error: any) {
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
    }
  };

  const changeState = (e: any) => {
    setState(e);
    fetchCities(e.value);
  };

  const fetchCities = async (stateId: string) => {
    const response = await getCities({
      token: token,
      stateId,
    });
    setCities(response.data.data);
  };

  const handleAcceptedFiles = async (files: any, hook: string) => {
    let position = 1;
    if (selectedFiles.length) {
      position = selectedFiles[selectedFiles.length - 1].position + 1;
    }
    const finalFiles = [];
    for (let file of files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "properties",
        });
        if (hook === "banner") {
          setBanner(response.data.data.image);
        } else {
          setImageTmp(response.data.data.image);
        }
        finalFiles.push({
          image: response.data.data.image,
          position,
        });
        position += 1;
      } catch (error: any) {
        console.log(error.response);
      }
    }
    setselectedFiles([...selectedFiles, ...finalFiles]);
  };

  const deleteImage = (index: number) => {
    let selectedFilesArray: any[] = [...selectedFiles];
    selectedFilesArray.splice(index, 1);
    setselectedFiles(selectedFilesArray);
  };

  const getPositions = () => {
    const max = selectedFiles[selectedFiles.length - 1].position;
    const result = [];
    for (let i = 1; i <= max; i++) {
      result.push({
        value: String(i),
        label: `posición ${i}`,
      });
    }
    return result;
  };

  const changePositionImage = (oldPos: number, newPos: number) => {
    newPos = Number(newPos);
    if (oldPos > newPos) {
      for (let i = oldPos; i > newPos; i--) {
        moveDownPositionImage(i);
      }
    } else {
      for (let i = oldPos; i < newPos; i++) {
        moveUpPositionImage(i);
      }
    }
  };

  const moveUpPositionImage = (pos: number) => {
    let selectedFilesArray: any[] = [...selectedFiles];
    selectedFilesArray.map((item, index) => {
      if (item.position === pos) {
        item.position += 1;
      } else if (item.position === pos + 1) {
        item.position -= 1;
      }
    });
    selectedFilesArray.sort((a: any, b: any) => {
      if (a.position > b.position) {
        return 1;
      }
      if (a.position < b.position) {
        return -1;
      }
      return 0;
    });
    setselectedFiles(selectedFilesArray);
  };

  const moveDownPositionImage = (pos: number) => {
    let selectedFilesArray: any[] = [...selectedFiles];
    selectedFilesArray.map((item, index) => {
      if (item.position === pos - 1) {
        item.position += 1;
      } else if (item.position === pos) {
        item.position -= 1;
      }
    });
    selectedFilesArray.sort((a: any, b: any) => {
      if (a.position > b.position) {
        return 1;
      }
      if (a.position < b.position) {
        return -1;
      }
      return 0;
    });
    setselectedFiles(selectedFilesArray);
  };

  const uploadCallback = async (file: any) => {
    const result = {
      data: {
        link: "",
      },
    };
    try {
      var form = new FormData();
      form.append("file", file);
      let response = await imageUpload({
        form,
        token: "",
        type: "textEdition",
      });
      result.data.link = `${Constants.BASE_URL}${response.data.data.image}`;
    } catch (error: any) {
      console.log(error.response);
    }
    return result;
  };

  const handleFiles = async (event: any) => {
    for (let file of event.target.files) {
      try {
        var form = new FormData();
        form.append("file", file);
        let response = await imageUpload({
          form,
          token: "",
          type: "banners",
        });
        setImageNewData(response.data.data.image);
      } catch (error: any) {
        console.log(error.response);
      }
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      let response = await getData({
        token: "",
      });
      const result: any[] = [];
      response.data.data.map((item: any) => {
        result.push({
          id: item.id,
          name: item.value,
          symbol: item.symbol ? `(${item.symbol})` : "",
          value: "",
          checked: false,
        });
      });
      setDatas(result);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const saveData = async () => {
    setLoading(true);
    try {
      let response = await postData({
        token: "",
        icon: imageNewData,
        value: nameNewData,
        symbol: symbolNewData,
      });
      setLoading(false);
      setImageNewData("");
      setNameNewData("");
      setSymbolNewData("");

      const { id, value, symbol } = response.data.data.data;
      setDatas([
        ...datas,
        {
          id: id,
          name: value,
          symbol: symbol ? `(${symbol})` : "",
          value: "",
          checked: false,
        },
      ]);
      toast(`Creado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const removeData = async (id: number, index: number) => {
    setLoading(true);
    try {
      let response = await deleteData({
        token: "",
        id,
      });
      setLoading(false);
      const datasTmp = [...datas];
      datasTmp.splice(index, 1);
      setDatas(datasTmp);
      toast(`Data eliminado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const fetchLabels = async () => {
    try {
      const response = await fetchPropertyLabels();
      setLabelsOptions(
        response.data.data.map((item: any) => ({
          value: item.id,
          label: item.name,
        }))
      );
    } catch (error) {}
  };

  const fetchTags = async () => {
    try {
      setLoading(true);
      let response = await getTags({
        token: "",
      });
      const result: any[] = [];
      response.data.data.map((item: any) => {
        result.push({
          id: item.id,
          name: item.value,
          checked: false,
        });
      });
      setTags(result);
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const saveTag = async () => {
    setLoading(true);
    try {
      let response = await postTag({
        token: "",
        value: nameNewTag,
      });
      setLoading(false);
      setNameNewTag("");
      const { id, value } = response.data.data.tag;
      setTags([
        ...tags,
        {
          id: id,
          name: value,
          checked: false,
        },
      ]);
      toast(`Creado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const removeTag = async (id: number, index: number) => {
    setLoading(true);
    try {
      let response = await deleteTag({
        token: "",
        id,
      });
      setLoading(false);
      const tagsTmp = [...tags];
      tagsTmp.splice(index, 1);
      setTags(tagsTmp);
      toast(`Data eliminado con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const changeChecked = (index: number) => {
    const tagsTmp = [...tags];
    tagsTmp[index].checked = !tagsTmp[index].checked;
    setTags(tagsTmp);
  };

  const changeCheckedData = (index: number) => {
    const datasTmp = [...datas];
    datasTmp[index].checked = !datasTmp[index].checked;
    setDatas(datasTmp);
  };

  const changeValueData = (value: string | any, index: number) => {
    const datasTmp = [...datas];
    datasTmp[index].value = value.value || value;
    setDatas(datasTmp);
  };

  const saveProperty = async () => {
    if (meliShared.value && !categoryWithOperationMeli) {
      toast.error(
        "Para compartir en MercadoLibre hay que seleccionar una categoría referencia",
        {
          position: toast.POSITION.BOTTOM_CENTER,
          pauseOnHover: false,
        }
      );
      return;
    }
    if (!checkCategory()) {
      return;
    }
    if (infoCasasShared.value && !infoCasasCategory.value) {
      toast.error(
        "Para compartir en InfoCasas hay que seleccionar una categoría referencia",
        {
          position: toast.POSITION.BOTTOM_CENTER,
          pauseOnHover: false,
        }
      );
      return;
    }
    if (infoCasasShared.value && !infoCasasCity.value) {
      toast.error(
        "Para compartir en InfoCasas hay que seleccionar una ciudad referencia",
        {
          position: toast.POSITION.BOTTOM_CENTER,
          pauseOnHover: false,
        }
      );
      return;
    }
    setLoading(true);
    try {
      let data = {
        selectedFiles,
        state: state.value,
        city: city.value,
        title,
        category: category.map((c: any) => c.value).join(","),
        address,
        money: money.value,
        price,
        lat: String(lat ?? "").replace(" ", ""),
        lng: String(lng ?? "").replace(" ", ""),
        typeOperation: typeOperation.value,
        isDevelopment: isDevelopment.value,
        isHighList: isHighList.value,
        youtube,
        description: stateToHTML(description.getCurrentContent()),
        tags,
        datas,
        featureOption: featuresOptionsSelect.value,
        urlsProperties,
        sold,
        rented,
        reserved,
        label: label.value,
        meliUrl,
        meliId,
        meliShared: meliShared.value,
        meliHighlight: meliHighlight.value,
        meliCategory: categoryWithOperationMeli,
        infoCasasShared: infoCasasShared.value,
        infoCasasCategory: infoCasasCategory.value,
        infoCasasCity: infoCasasCity.value,
        reference,
      };
      let response = null;
      if (Number(id) !== 0) {
        response = await editProperty({
          token,
          id,
          ...data,
        });
        window.scrollTo(0, 0);
      } else {
        response = await addProperty({
          token,
          ...data,
        });
        history.push("/properties");
      }
      if (response?.data?.data?.property?.meli_url) {
        setMeliUrl(response?.data?.data?.property?.meli_url);
      }
      setLoading(false);
      toast(`Propiedad guardada con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    } catch (error: any) {
      console.log(error?.response);
      setLoading(false);
      if (error?.response?.status === 401) {
        history.push("/logout");
      }
      const responseData = error?.response?.data;
      let msg = "Ocurrió un error al procesar la solicitud, reintentar";
      if (
        responseData?.message?.cause?.length &&
        responseData?.message?.cause[0]?.message
      ) {
        msg = responseData?.message?.cause[0]?.message;
      } else if (responseData?.message?.message === "Not available quota") {
        msg =
          "Se llegó al máximo de publicaciones destacadas en MercadoLibre, deja de destacar alguna para poder destacar esta propiedad";
      } else if (typeof responseData?.message?.message === "string") {
        msg = responseData.message.message;
      } else if (typeof responseData?.message === "string") {
        msg = responseData.message;
        if (responseData?.error) {
          msg += `: ${responseData.error}`;
        }
      } else if (error?.request && !error?.response) {
        msg = "No se pudo conectar con el servidor, revisá tu conexión";
      } else if (!error?.response) {
        console.error(error);
        msg = `Error al preparar los datos: ${error?.message || error}`;
      }
      toast.error(msg, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const onChangeCategoryMeliSelect = async (e: any) => {
    const result = (await getCategory(e.value, token)) as any;
    let categoryWithOperation = result.children_categories.find(
      (i: any) => i.name === typeOperation.label
    );
    let categoryWithOperationId;
    if (!categoryWithOperation) {
      categoryWithOperation = result.children_categories[0];
    }
    categoryWithOperationId = categoryWithOperation.id;
    if (categoryWithOperationId === "MLU455671") {
      categoryWithOperationId = "MLU1468";
    } else if (categoryWithOperationId === "MLU455676") {
      categoryWithOperationId = "MLU1474";
    } else if (categoryWithOperationId === "MLU455678") {
      categoryWithOperationId = "MLU1495";
    } else if (categoryWithOperationId === "MLU455681") {
      categoryWithOperationId = "MLU50635";
    }
    setCategoryWithOperationMeli(categoryWithOperationId);
    setCategoryMeliSelect(e);
  };

  const checkCategory = () => {
    if (["MLU1495", "MLU1494"].includes(categoryWithOperationMeli || "")) {
      // checkear si hay TOTAL_AREA y LAND_ACCESS
      const totalArea = datas.find((d: any) => d.id === 15);
      const landAccess = datas.find((d: any) => d.id === 23);
      if (!totalArea?.value || !landAccess?.value) {
        toast.error(
          "Para la categoría Terrenos y Lotes de MercadoLibre se deben completar los campos de 'm2 Terreno (m²)' y 'acceso'",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            pauseOnHover: false,
          }
        );
        return false;
      }
    } else if (
      ["MLU50637", "MLU50638"].includes(categoryWithOperationMeli || "")
    ) {
      const totalArea = datas.find((d: any) => d.id === 15);
      if (!totalArea?.value) {
        toast.error(
          "Para la categoría Cocheras de MercadoLibre se deben completar el campo de 'm2 Terreno (m²)'",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            pauseOnHover: false,
          }
        );
        return false;
      }
    } else {
      let isRequiredDatasCompleted = true;
      for (const data of datas) {
        if ([14, 15, 16, 17].includes(data.id)) {
          if (!data.value) {
            isRequiredDatasCompleted = false;
          }
          continue;
        }
      }
      if (!isRequiredDatasCompleted) {
        toast.error(
          "Para compartir en MercadoLibre se deben completar los campos de 'm2 Terreno (m²)', 'Baños', 'Dormitorios' y 'm2 Edificados (m²)'",
          {
            position: toast.POSITION.BOTTOM_CENTER,
            pauseOnHover: false,
          }
        );
        return false;
      }
    }
    return true;
  };

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div id="Properties" className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Propiedades" breadcrumbItem="Propiedades" />
          <Row>
            <Col>
              {/*
              <FormGroup>
                <Label>Banner</Label>
                <Dropzone
                  onDrop={(acceptedFiles) => {
                    handleAcceptedFiles(acceptedFiles, "banner");
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick mt-2"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3 mb-3" id="file-previews">
                  {banner && (
                    <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                      <div className="p-2">
                        <Row className="align-items-center">
                          <Col className="col-auto">
                            <img
                              data-dz-thumbnail=""
                              height="80"
                              className="avatar-sm rounded bg-light"
                              alt=""
                              src={`${Constants.BASE_URL}${banner}`}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  )}
                </div>
              </FormGroup>*/}
              <Form method="post">
                <h5>Datos generales</h5>
                <div className="row">
                  <div className="col-4">
                    <FormGroup>
                      <Label>Título</Label>
                      <Input
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-4">
                    <FormGroup>
                      <Label>Categoría</Label>
                      <Select
                        value={category}
                        placeholder="Seleccione una o más categoría"
                        options={categories}
                        onChange={(e: any) => setCategory(e)}
                        isMulti
                      />
                    </FormGroup>
                  </div>
                  <div className="col-4">
                    <FormGroup>
                      <Label>Referencia</Label>
                      <Input
                        value={reference}
                        onChange={(e) => setReference(e.target.value)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-4">
                    <FormGroup className="mt-2">
                      <Label>Departamento</Label>
                      <Select
                        value={state}
                        placeholder="Seleccione un departamento"
                        // value={type}
                        // onChange={(e: any) => setType(e)}
                        options={states.map((item: any) => ({
                          value: item.id,
                          label: item.name,
                        }))}
                        onChange={changeState}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-4">
                    <FormGroup className="mt-2">
                      <Label>Ciudad</Label>
                      <Select
                        value={city}
                        placeholder="Seleccione una ciudad"
                        // value={type}
                        // onChange={(e: any) => setType(e)}
                        options={cities.map((item: any) => ({
                          value: item.id,
                          label: item.name,
                        }))}
                        onChange={(e: any) => setCity(e)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-4">
                    <FormGroup className="mt-2">
                      <Label>Dirección</Label>
                      <Input
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-3">
                    <FormGroup className="mt-2">
                      <Label>Moneda</Label>
                      <Select
                        value={money}
                        // onChange={(e: any) => setType(e)}
                        options={[
                          { value: "uyu", label: "UYU" },
                          { value: "usd", label: "USD" },
                        ]}
                        onChange={(e: any) => setMoney(e)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-2">
                    <FormGroup className="mt-2">
                      <Label>Precio</Label>
                      <Input
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-2">
                    <FormGroup className="mt-2">
                      <Label>Latitud</Label>
                      <Input
                        value={lat}
                        onChange={(e) => setLat(e.target.value)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-2">
                    <FormGroup className="mt-2">
                      <Label>Longitud</Label>
                      <Input
                        value={lng}
                        onChange={(e) => setLng(e.target.value)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-2">
                    <FormGroup className="mt-2">
                      <Label>Referencia</Label>
                      <Input
                        value={reference}
                        onChange={(e) => setReference(e.target.value)}
                      />
                    </FormGroup>
                  </div>

                  <div className="col-2">
                    <FormGroup className="mt-2">
                      <Label>Tipo de operación</Label>
                      <Select
                        value={typeOperation}
                        // onChange={(e: any) => setType(e)}
                        options={[
                          { value: "venta", label: "Venta" },
                          { value: "alquiler", label: "Alquiler" },
                        ]}
                        onChange={(e: any) => setTypeOperation(e)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-2">
                    <FormGroup className="mt-2">
                      <Label>Es desarrollo</Label>
                      <Select
                        value={isDevelopment}
                        // onChange={(e: any) => setType(e)}
                        options={[
                          { value: "no", label: "No" },
                          { value: "si", label: "Si" },
                        ]}
                        onChange={(e: any) => setIsDevelopment(e)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-2">
                    <FormGroup className="mt-2">
                      <Label>Destacado?</Label>
                      <Select
                        value={isHighList}
                        // onChange={(e: any) => setType(e)}
                        options={[
                          { value: "no", label: "No" },
                          { value: "si", label: "Si" },
                        ]}
                        onChange={(e: any) => setIsHighList(e)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-3">
                    <FormGroup className="mt-2">
                      <Label>Link de youtube</Label>
                      <Input
                        value={youtube}
                        onChange={(e) => setYoutube(e.target.value)}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-3">
                    <FormGroup className="mt-2">
                      <Label>Etiqueta</Label>
                      <Select
                        value={label}
                        onChange={(e: any) => setLabel(e)}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base: any) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                        }}
                        options={[
                          { value: "", label: "Sin etiqueta" },
                          ...labelsOptions,
                        ]}
                      />
                    </FormGroup>
                  </div>

                  <div className="col-12">
                    <FormGroup className="mt-2">
                      <Label>Descripción</Label>
                      <Editor
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorClassName"
                        toolbar={{
                          options: [
                            "inline",
                            "blockType",
                            "link",
                            "emoji",
                            "image",
                          ],
                          inline: { inDropdown: true },
                          link: { inDropdown: true },
                          image: { uploadCallback },
                        }}
                        editorState={description}
                        onEditorStateChange={(d: any) => setDescription(d)}
                      />
                    </FormGroup>
                  </div>
                </div>

                <h5 className="mt-4">Ficha técnica</h5>
                <div className="row mb-4">
                  <div className="col-12">
                    <Label>Agregar nuevo item de ficha técnica</Label>
                    <Row>
                      <div className="col-6" style={{ display: "flex" }}>
                        <Input
                          placeholder="Ingrese nombre"
                          style={{ marginRight: "0.5rem" }}
                          value={nameNewData}
                          onChange={(e) => setNameNewData(e.target.value)}
                        />
                        <Input
                          placeholder="Ingrese simbolo"
                          value={symbolNewData}
                          onChange={(e) => setSymbolNewData(e.target.value)}
                        />
                      </div>
                      <div className="col-6" style={{ display: "flex" }}>
                        <CustomInput
                          id="file"
                          type="file"
                          name="file"
                          className="custom-file-input"
                          onChange={handleFiles}
                          style={{ marginTop: "0.5rem" }}
                        />
                        <Button
                          style={{ marginLeft: "0.5rem" }}
                          onClick={() => saveData()}
                        >
                          Agregar
                        </Button>
                      </div>
                    </Row>
                  </div>
                </div>

                <div className="row">
                  {datas?.map((item, index) => (
                    <div className="col-3" key={item.id}>
                      <FormGroup className="mb-2">
                        <Label>
                          {item.name} {item.symbol}
                        </Label>
                        <div style={{ display: "flex" }}>
                          {item.id === 23 ? (
                            <Creatable
                              onChange={(value: any) =>
                                changeValueData(value, index)
                              }
                              options={LAND_ACCESS}
                              value={LAND_ACCESS.find(
                                (option) => option.value === item.value
                              )}
                              className="form-control"
                              id="land-access"
                              placeholder="Seleccionar acceso"
                            />
                          ) : (
                            <Input
                              value={item.value}
                              onChange={(e) =>
                                changeValueData(e.target.value, index)
                              }
                            />
                          )}
                          {![12, 14, 15, 16, 17, 23].includes(item.id) && (
                            <Button
                              style={{
                                height: "25px",
                                padding: "0",
                                width: "25px",
                                marginLeft: "-25px",
                              }}
                              onClick={() => removeData(item.id, index)}
                            >
                              X
                            </Button>
                          )}
                          <div style={{ textAlign: "center" }}>
                            <label
                              style={{ fontSize: "10px", marginBottom: "0" }}
                            >
                              Dest.
                            </label>
                            <Input
                              type="checkbox"
                              checked={item.checked}
                              onChange={() => changeCheckedData(index)}
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </div>
                  ))}
                </div>

                <h5 className="mt-4">Características</h5>
                <Creatable
                  onChange={(value: any) => setFeaturesOptionsSelect(value)}
                  options={featuresOptions}
                  value={featuresOptionsSelect}
                  id="creatable"
                />
                <div className="row mb-4 mt-3">
                  <div className="col-12">
                    <Label>Agregar nueva característica</Label>
                    <Row>
                      <div className="col-6" style={{ display: "flex" }}>
                        <Input
                          placeholder="ingrese nombre"
                          value={nameNewTag}
                          onChange={(e) => setNameNewTag(e.target.value)}
                        />
                        <Button
                          style={{ marginLeft: "0.5rem" }}
                          onClick={() => saveTag()}
                        >
                          Agregar
                        </Button>
                      </div>
                    </Row>
                  </div>
                </div>
                <div className="row">
                  {tags.map((item, index) => (
                    <div className="col-2" key={item.id}>
                      <FormGroup className="mt-2">
                        <Input
                          type="checkbox"
                          checked={item.checked}
                          onChange={() => changeChecked(index)}
                        />
                        <Label>{item.name}</Label>
                        <Button
                          style={{
                            height: "15px",
                            padding: "0",
                            width: "15px",
                            marginLeft: "0.25rem",
                            fontSize: "10px",
                          }}
                          onClick={() => removeTag(item.id, index)}
                        >
                          X
                        </Button>
                      </FormGroup>
                    </div>
                  ))}
                </div>

                {isDevelopment.value.toUpperCase() === "SI" && (
                  <>
                    <h5 className="mt-4">Propiedades</h5>
                    <div className="row mb-4 mt-3">
                      <div className="col-12">
                        <Label>Agregar url propiedad</Label>
                        <Row>
                          <div className="col-6" style={{ display: "flex" }}>
                            <Input
                              placeholder="Ingrese url"
                              value={newUrlProperty}
                              onChange={(e) =>
                                setNewUrlProperty(e.target.value)
                              }
                            />
                            <Button
                              style={{ marginLeft: "0.5rem" }}
                              onClick={() => {
                                setNewUrlProperty("");
                                setUrlsProperties([
                                  ...urlsProperties,
                                  newUrlProperty,
                                ]);
                              }}
                            >
                              Agregar
                            </Button>
                          </div>
                        </Row>
                      </div>
                    </div>
                    <div className="row">
                      {urlsProperties.map((item: any, index: number) => (
                        <div className="col-2" key={index}>
                          <FormGroup className="mt-2">
                            <Label>{item}</Label>
                            <Button
                              style={{
                                height: "15px",
                                padding: "0",
                                width: "15px",
                                marginLeft: "0.25rem",
                                fontSize: "10px",
                              }}
                              onClick={() => {
                                const urlsPropertiesTmp = [...urlsProperties];
                                urlsPropertiesTmp.splice(index, 1);
                                setUrlsProperties(urlsPropertiesTmp);
                              }}
                            >
                              X
                            </Button>
                          </FormGroup>
                        </div>
                      ))}
                    </div>
                  </>
                )}

                <h5 className="mt-4">Imagenes</h5>
                <div className="row">
                  <div className="col-12">
                    <Dropzone
                      onDrop={(acceptedFiles) => {
                        handleAcceptedFiles(acceptedFiles, "image");
                      }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone">
                          <div
                            className="dz-message needsclick mt-2"
                            {...getRootProps()}
                          >
                            <input {...getInputProps()} />
                            <div className="mb-3">
                              <i className="display-4 text-muted bx bxs-cloud-upload" />
                            </div>
                            <h4>Drop files here or click to upload.</h4>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <div className="dropzone-previews mt-3" id="file-previews">
                      {selectedFiles.map((f: any, i: number) => {
                        return (
                          <Card
                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                            key={i + "-file"}
                          >
                            <div className="p-2">
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    data-dz-thumbnail=""
                                    height="80"
                                    className="avatar-sm rounded bg-light"
                                    alt=""
                                    src={`${Constants.BASE_URL}${f.image}`}
                                  />
                                </Col>
                                <Col
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Select
                                    placeholder="prueba"
                                    onChange={(e: any) =>
                                      changePositionImage(f.position, e.value)
                                    }
                                    value={{
                                      value: String(f.position),
                                      label: `posición ${f.position}`,
                                    }}
                                    options={getPositions()}
                                  />
                                  <div
                                    onClick={() => deleteImage(i)}
                                    style={{
                                      margin: "1px 1rem 0px auto",
                                      cursor: "pointer",
                                    }}
                                  >
                                    X
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Card>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </Form>
              <div className="row">
                <div className="col-12">
                  <h5 className="mt-4">MercadoLibre</h5>
                  <div className="row">
                    <div className="col-4">
                      <label style={{ marginRight: "0.5rem" }}>
                        Compartir en MercadoLibre
                      </label>
                      <Select
                        value={meliShared}
                        onChange={(e: any) => setMeliShared(e)}
                        options={[
                          { value: 0, label: "No" },
                          { value: 1, label: "Si" },
                        ]}
                      />
                    </div>
                    <div className="col-4">
                      <label style={{ marginRight: "0.5rem" }}>
                        Compartir en sección destacados
                      </label>
                      <Select
                        value={meliHighlight}
                        onChange={(e: any) => setMeliHighlight(e)}
                        options={[
                          { value: 0, label: "No" },
                          { value: 1, label: "Si" },
                        ]}
                      />
                    </div>
                    <div className="col-4">
                      <label style={{ marginRight: "0.5rem" }}>Categoría</label>
                      <Select
                        value={categoryMeliSelect}
                        onChange={(e: any) => onChangeCategoryMeliSelect(e)}
                        options={categoryMeli?.children_categories?.map(
                          (item: any) => ({
                            value: item.id,
                            label: item.name,
                          })
                        )}
                      />
                    </div>
                    {meliUrl && (
                      <div className="col-12 mt-2">
                        <label>
                          Compartiendo URL:{" "}
                          <a href={meliUrl} target="_blank" rel="noreferrer">
                            {meliUrl}
                          </a>
                        </label>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <h5 className="mt-4">InfoCasas</h5>
                  <div className="row">
                    <div className="col-4">
                      <label style={{ marginRight: "0.5rem" }}>
                        Compartir en InfoCasas
                      </label>
                      <Select
                        value={infoCasasShared}
                        onChange={(e: any) => setInfoCasasShared(e)}
                        options={[
                          { value: 0, label: "No" },
                          { value: 1, label: "Si" },
                        ]}
                      />
                    </div>
                    <div className="col-4">
                      <label style={{ marginRight: "0.5rem" }}>Categoría</label>
                      <Select
                        value={infoCasasCategory}
                        onChange={(e: any) => setInfoCasasCategory(e)}
                        placeholder="Seleccione una categoría"
                        options={INFO_CASAS_CATEGORIES.map((item: any) => item)}
                      />
                    </div>
                    <div className="col-4">
                      <label style={{ marginRight: "0.5rem" }}>Ciudad</label>
                      <Select
                        value={infoCasasCity}
                        onChange={(e: any) => setInfoCasasCity(e)}
                        placeholder="Seleccione una categoría"
                        options={(
                          INFO_CASAS_CITIES[
                            states &&
                              states.find(
                                (stateTmp: any) =>
                                  state && state.value === stateTmp.id
                              )?.info_casas_code
                          ] || []
                        ).map((item: any) => item)}
                      />
                      {console.log(states)}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="row"
                style={{ marginTop: "1rem", marginBottom: "1rem" }}
              >
                <div className="col-12 text-right">
                  {Number(id) !== 0 && (
                    <ViewInWeb
                      link={`https://mariomendez.uy/propiedades/${id}`}
                    />
                  )}
                  <button
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => saveProperty()}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Properties;
